"use client";

import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { CockpitPageHeader } from "@/components/cockpit/CockpitPageHeader";
import { KrisenplanGenerator } from "@/components/cockpit/KrisenplanGenerator";

export const Route = createFileRoute("/_cockpit/cockpit/hundert-tage/vorlagen/krisenplan")({
  head: () => ({
    meta: [
      { title: "Krisenplan – 100 Tage im Amt – Cockpit – creategy" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: KrisenplanRoute,
});

/** Ticket Z11: Eigene Unterseite für den Krisenplan zum Aushängen. */
function KrisenplanRoute() {
  return (
    <div className="space-y-8">
      <div>
        <Link
          to="/cockpit/hundert-tage"
          className="inline-flex items-center gap-1 text-sm font-semibold text-primary hover:underline"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden />
          Zurück zur Übersicht
        </Link>
        <div className="mt-3">
          <CockpitPageHeader
            title="Krisenplan"
            description="Erreichbarkeitsregel und Muster-Erststatement in einem Dokument – zum Aushängen, damit es im Ernstfall griffbereit hängt."
          />
        </div>
      </div>

      <KrisenplanGenerator />
    </div>
  );
}
